
// Note: DO NOT edit this file or any module files during projects. 
// Use the child-theme `index.js` to extend or create logic in projects.

// CSS/Sass
import '../scss/main.scss';

// Global
import jQuery from 'jquery';
import 'jquery-match-height';

// Vendors (List alphabetically)

// Modules (List alphabetically)
import { getTailwindConfig } from './utility/tailwind';
import Accordion from './modules/Accordion';
import AnchoredScrollSection from './modules/AnchoredScrollSection';
import GallerySlider from './modules/GallerySlider';
import ImageHoverReveal from './modules/ImageHoverReveal';
import LoadMore from './modules/LoadMore';
import LogosSlider from './modules/LogosSlider';
import Map from './modules/Map';
import OffCanvasMenu from './modules/OffCanvasMenu';
import PostsSlider from './modules/PostsSlider';
import RelatedPostsSlider from './modules/RelatedPostsSlider';
import SearchDropdown from './modules/SearchDropdown';
import SearchResultsLoadMore from './modules/SearchResultsLoadMore';
import Select from './modules/Select';
import Tabs from './modules/Tabs';

//
// Set jQuery
//
// TODO: Not sure if this is required going forward. 
// Retest with jQuery-reliant blocks and remove if not required.
//

window.$ = jQuery;
window.jQuery = jQuery;


// Trigger the block loader plugin in Webpack.
// TODO: Move this into separate file.

if (typeof includeChildAssets === 'function') {
    includeChildAssets()
}
if (typeof includeBlocks === 'function') {
    includeBlocks()
}
